import SeparateLine from '@/shared/Forms/SeparateLine'
import SidePage from '@/shared/SidePage'
import Tabs from '@/shared/Tabs'
import { useState } from 'react'
import PersonalDataContent from '@/pages/User/AccountSettingsSidePage/PersonalDataContent'
import NotificationsContent from '@/pages/User/AccountSettingsSidePage/NotificationsContent'

interface IProps {
  open: boolean
  onClose: () => void
}

const AccountSettingsSidePage = (props: IProps) => {
  const [selectedTab, setSelectedTab] = useState('personal-data')

  const renderContent = () => {
    if (selectedTab === 'personal-data') {
      return <PersonalDataContent onClose={props.onClose} />
    }

    return <NotificationsContent onClose={props.onClose} />
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} style={{ paddingRight: 0 }}>
      <div className="flex-lines gap16 height100">
        <h4 className="text-heading-4">Настройки аккаунта</h4>
        <SeparateLine />
        <div style={{ marginTop: '-16px' }}>
          <Tabs
            tabs={[
              { title: 'Личные данные', id: 'personal-data' },
              { title: 'Уведомления', id: 'notifications' },
            ]}
            onSelect={setSelectedTab}
            selectedTab={selectedTab}
          />
        </div>
        {renderContent()}
      </div>
    </SidePage>
  )
}

export default AccountSettingsSidePage
